import { createFileRoute } from "@tanstack/react-router";
import { breadcrumbJsonLd } from "@/lib/breadcrumb-jsonld";
import { LegalLayout, COMPANY } from "@/components/site/LegalLayout";
import { SHIPPING_POLICY_TEXT } from "@/lib/commerce";

export const Route = createFileRoute("/verzendbeleid")({
  head: () => ({
    meta: [
      { title: "Verzending & levering — Elvion Group Nederland" },
      { name: "description", content: "Levertijden, verzendkosten, Track & Trace en afhalen bij Elvion Group Nederland. Gratis verzending in Nederland vanaf €150." },
      { name: "robots", content: "index,follow" },
      { property: "og:title", content: "Verzending & levering — Elvion Group Nederland" },
      { property: "og:description", content: "Duidelijke verzendinformatie: levertijden, verzendkosten, Track & Trace en afhalen in Wageningen." },
      { property: "og:url", content: "https://elvion-group.nl/verzendbeleid" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:title", content: "Verzending & levering — Elvion Group Nederland" },
      { name: "twitter:description", content: "Levertijden, verzendkosten en bezorging bij Elvion Group Nederland." },
    ],
    links: [{ rel: "canonical", href: "https://elvion-group.nl/verzendbeleid" }],
    scripts: [breadcrumbJsonLd([{ name: "Verzendbeleid", path: "/verzendbeleid" }])],
  }),
  component: () => (
    <LegalLayout title="Verzending & levering">
      <h2>Levertijd</h2>
      <p>Producten die op voorraad zijn, worden op werkdagen vóór 16:00 uur besteld dezelfde dag verzonden. De gemiddelde levertijd binnen Nederland is <strong>1–2 werkdagen</strong>. Voor België geldt 2–3 werkdagen.</p>
      <p>Bij producten die niet direct leverbaar zijn, wordt de verwachte levertijd op de productpagina vermeld. Uiterlijk binnen 30 dagen na bestelling ontvangt u uw bestelling, tenzij anders overeengekomen.</p>

      <h2>Verzendkosten</h2>
      <ul>
        <li>Nederland: € 6,95 inclusief btw — <strong>alleen binnen Nederland gratis verzending vanaf € 150,– inclusief btw</strong></li>
        <li>België: € 9,95</li>
        <li>Grote / pallet-zendingen: op aanvraag, vooraf vermeld in de offerte</li>
      </ul>
      <p>{SHIPPING_POLICY_TEXT}</p>
      <p>De verzendkosten die u op productpagina's, in de checkout en in onze productfeed ziet, volgen dezelfde uitgangspunten. Eventuele afwijkende kosten voor grote zendingen worden altijd vóór betaling getoond.</p>

      <h2>Vervoerders</h2>
      <p>Wij versturen pakketten met PostNL en DHL. U ontvangt na verzending een Track &amp; Trace per e-mail.</p>

      <h2>Afhalen</h2>
      <p>Afhalen op afspraak is mogelijk op ons vestigingsadres: {COMPANY.address}, {COMPANY.postal}. Neem hiervoor vooraf contact op via {COMPANY.phone}.</p>

      <h2>Beschadiging of vermissing</h2>
      <p>Controleer uw zending bij ontvangst. Meld eventuele schade of vermissing binnen 48 uur bij {COMPANY.email}, zodat wij dit met de vervoerder kunnen oplossen.</p>

      <h2>Levering buiten EU</h2>
      <p>Wij leveren standaard binnen Nederland en België. Levering buiten de EU op aanvraag.</p>
    </LegalLayout>
  ),
});
